import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Helpers
import { isEmptyString } from 'Shared/helpers';

// Actions
import { advanceOnboardingStateAction } from 'Shared/actions/onboardingState';

// Components
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import { WpRadioGroup, WpRadioInput } from 'Wpds/components/radio';

// Selectors
import * as OnboardingStateSelectors from 'Shared/selectors/OnboardingState.selectors';

// Styles
import './AboutYou.scss';

const AboutYou = () => {
  const dispatch = useDispatch();

  const profile = useSelector(state => OnboardingStateSelectors.getProfile(state));

  const name = profile.fullName;
  const role = profile.role || 'manager';

  const handleSubmit = values => {
    dispatch(
      advanceOnboardingStateAction({
        onboardingState: {
          profile: {
            fullName: values.name_input,
            role: values.role_input,
          },
        },
        didSkip: false,
      })
    );
  };

  const baseClassName = 'AboutYou';
  return (
    <div className={baseClassName}>
      <WpForm onSubmit={handleSubmit}>
        <WpFormLayout direction="horizontal">
          <WpTextField
            id="name_input"
            type="text"
            label="Your Full Name"
            placeholder="Dalton Bartoletti"
            value={name}
            required
            validate={{
              isValidName: {
                callback: value => !isEmptyString(value),
                error: 'Please enter a valid name',
              },
            }}
          />
          <WpRadioGroup id="role_input" label="Your role" required direction="horizontal" defaultValue={role}>
            <WpRadioInput id="manager" label="Manager" value="manager" />
            <WpRadioInput id="full_member" label="Individual Contributor" value="full_member" />
          </WpRadioGroup>
        </WpFormLayout>
        <div className={`${baseClassName}__footer`}>
          <WpButtonGroup>
            <WpButton btnType="submit" qaTest="about-you-next">
              Next
            </WpButton>
          </WpButtonGroup>
        </div>
      </WpForm>
    </div>
  );
};

export default AboutYou;
